<script>
export default {
  name: 'InputLabel',
  props: {
    name: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    tooltip: {
      type: String,
      default: null,
    },
    tooltipIcon: {
      type: String,
      default: 'pi-info-circle',
    },
    required: {
      type: Boolean,
      default: false,
    },
    forNonNativeElement: {
      type: Boolean,
      default: false,
    },
    srOnly: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <div class="flex items-center mb-1" :class="{ 'sr-only': srOnly }">
    <span v-if="forNonNativeElement" :class="$style.label" :id="name">{{
      label
    }}</span>
    <div v-else :class="[$style.label, 'flex items-center']">
      <label :for="name">{{ label }}</label>
      <span v-if="required" class="text-red-600">*</span>
      <i
        v-if="tooltip"
        :class="`pi ml-1 ${tooltipIcon}`"
        v-tooltip.top="tooltip"
      ></i>
      <slot></slot>
    </div>
  </div>
</template>

<style module>
.label {
  margin: 0;
  display: block;
  padding: 0;
  font-family: Manrope, system-Helvetica, 'Segoe UI', sans-serif;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  font-style: normal;
  text-decoration-line: none;
  text-decoration-color: #5f5f61;
}
</style>
